import React, { useState } from "react";
import * as moment from "moment";
import { GrAdd } from "react-icons/gr";
import { TypeBestOf } from "../../model/TypeBestOf";
import { useBestOf } from "../../context/BestOf";
import { useMenuBestOf } from "../../context/MenuBestOf";
import settings from "../../../../settings";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  containerItemPost: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.palette.background.default,
    marginBottom: "10px",
    borderRadius: "10px"
  },
  itemPostImage: {
    maxWidth: "35%",
    height: "auto !important",
    borderRadius: "10px 0px 0px 10px"
  },
  containerItemInfoPost: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "90%"
  },
  itemPublishedDate: { fontSize: "12px", margin: "0" },
  itemTitle: { fontSize: "1em", margin: "0" },
  clickableItemPost: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.palette.background.default,
    marginBottom: "10px",
    borderRadius: "10px",
    cursor: "pointer",

    "&:hover" : {
      backgroundColor: theme.palette.background.paper,
    }
  }
}));

const Item = ({ item }: any) => {
  const classes = useStyles();
  const [over, setOver] = useState(false);
  const { dispatch } = useBestOf();
  const { state: stateMenu } = useMenuBestOf();

  return (
    <div
      className={classes.containerItemPost}
      onClick={() =>
        stateMenu.typeBestOf === TypeBestOf.DAYS
          ? dispatch({
              type: "ADD_ARTICLE_POST_DAY",
              payload: {
                day: moment.utc(item.published_at).format("dddd"),
                post: item,
              },
            })
          : dispatch({
              type: "ADD_ARTICLE_POST_DAY",
              payload: { day: null, post: item },
            })
      }
    >
      <div
        className={classes.clickableItemPost}
        onMouseEnter={() => {
          setOver(true);
        }}
        onMouseLeave={() => {
          setOver(false);
        }}
      >
        {item.feature_image ? (
          <img
            className={classes.itemPostImage}
            alt={item.feature_image}
            src={item.feature_image}
          />
        ) : (
          <img
          className={classes.itemPostImage}
            alt="Prévisualisation de l'article"
            src="https://static.ghost.org/v3.0.0/images/welcome-to-ghost.png"
          />
        )}
        <div className={classes.containerItemInfoPost}>
          <h3 className={classes.itemTitle}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${settings.bestOfArticlePath}/${item.slug}`}
              style={{ textDecoration: "none", color: "black" }}
            >
              {item.title}
            </a>
          </h3>
          <p className={classes.itemPublishedDate}>
            Publié le :
            {moment.utc(item.published_at).format("DD/MM/YYYY - hh:mm")}
          </p>
        </div>
        {over && <GrAdd color={"#b5b5b5"} size={30} />}
      </div>
    </div>
  );
};

export default Item;
